import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import Svg, { Path } from 'react-native-svg';

import { ModernPalette } from '@/constants/theme';
import { Spacing } from '@/constants/spacing';
import { getBodyFont } from '@/constants/typography';

const ARROW_COLOR = ModernPalette.textTertiary;

/**
 * Blank state shown below "Coming up" when no AI suggestions exist yet.
 * Nudges the user to tap the FAB for suggestions from Fim.
 */
export function SuggestionBlankState() {
  return (
    <View style={styles.container}>
      <Text style={styles.nudgeText}>
        Missing something?{'\n'}Check out suggestions from Fim
      </Text>

      <Svg
        width={60}
        height={100}
        viewBox="0 0 60 100"
        style={styles.arrow}
      >
        {/* Curved arrow body */}
        <Path
          d="M30 0 C30 30, 50 40, 40 65 C35 78, 30 85, 30 92"
          stroke={ARROW_COLOR}
          strokeWidth={1.5}
          fill="none"
          strokeLinecap="round"
        />
        {/* Arrowhead */}
        <Path
          d="M24 85 L30 96 L36 85"
          stroke={ARROW_COLOR}
          strokeWidth={1.5}
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </Svg>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    paddingTop: Spacing.md,
    paddingBottom: Spacing.md,
    gap: Spacing.sm,
  },
  nudgeText: {
    fontFamily: getBodyFont(),
    fontSize: 13,
    lineHeight: 20,
    color: ModernPalette.textTertiary,
    textAlign: 'center',
  },
  arrow: {
    marginTop: Spacing.xs,
  },
});
